import { useDataView } from '@va/dashboard/util-hooks';
import { ChartVisualizationComponentProps, LineDiagramOptions } from '@va/types/charts';
import { DataViewOption, DataViewToggle } from '@va/types/report-block';
import { useMemo } from 'react';
import { BarChartViewComponent } from './BarChartViewComponent';
import { LineDiagramViewComponent } from './LineDiagramViewComponent';
import { RadarChartViewComponent } from './RadarChartViewComponent';
import { TableViewComponent, TableViewComponentProps } from './table-view/TableViewComponent';

export type VisualizationComponentsCfg = ChartVisualizationComponentProps & TableViewComponentProps & { id: string };

export const buildVisualizationComponentsCfg = (cfg: VisualizationComponentsCfg) => cfg;

export const useVisualizationComponents = (cfg: VisualizationComponentsCfg) => {
  const visualizationComponents = useMemo(() => {
    return {
      [DataViewOption.lineDiagram]: () => <LineDiagramViewComponent {...cfg} />,
      [DataViewOption.stackedLineDiagram]: () => (
        <LineDiagramViewComponent {...cfg} lineDiagramType={LineDiagramOptions.STACKED} />
      ),
      [DataViewOption.steppedLineDiagram]: () => (
        <LineDiagramViewComponent {...cfg} lineDiagramType={LineDiagramOptions.STEPPED} />
      ),
      [DataViewOption.table]: () => <TableViewComponent {...cfg} />,
      [DataViewOption.barChart]: () => <BarChartViewComponent {...cfg} />,
      [DataViewOption.radarDiagram]: () => <RadarChartViewComponent {...cfg} />,
    };
  }, [cfg]);

  const visualizationOptions = useDataView({
    defaultView: DataViewOption.lineDiagram,
    identifier: cfg.id,
    options: [
      {
        view: DataViewOption.lineDiagram,
        options: [DataViewOption.lineDiagram, DataViewOption.stackedLineDiagram, DataViewOption.steppedLineDiagram],
        toggles: [
          { id: DataViewToggle.displayTrendLine },
          { id: DataViewToggle.displayDataPoints },
          { id: DataViewToggle.highlightMinMax },
        ],
      },
      DataViewOption.table,
      {
        view: DataViewOption.barChart,
        options: [DataViewOption.barChart],
        toggles: [{ id: DataViewToggle.displayTrendLine }, { id: DataViewToggle.displayDataPoints }],
      },
      DataViewOption.radarDiagram,
    ],
  });

  return { visualizationComponents, visualizationOptions };
};
